import React from 'react';
import Overlay from '../Overlay';
import SimpleTable from '../tables/SimpleTable';
import FilterCard, { FIELD_TYPE, ReactSelect } from '../FilterCard';
import {
  formatCurrencyWithoutDecimals,
  getBoolSelectVal,
  getDataForTableFromJSON,
  getLabels,
  getNumPages,
  getPageOptions,
  hideModal,
  newGetLabel,
  parseDate,
  showModalNoOutsideClick,
  slicePages,
} from '../../util/FormatUtil';
import { sweetalert } from '../../App';
import Select from 'react-select';
import { Result } from '../../types/Result';
import { ResultsManagementModal } from '../modals/ResultsManagementModal';
import NetworkUtil from '../../network/NetworkUtil';
import ResultsAPI from '../../network/ResultsAPI';
import { Column } from '../tables/TableBase';
import { Sorter, TableOrder } from '../../sorting/Sorter';
import PaginationTool from '../PaginationTool';
import SystemAPI from '../../network/SystemAPI';
import { AdminPages } from './AdminNav';
import { Product } from '../../types/Product';
import ShopAPI from '../../network/ShopAPI';
import { Order } from '../../types/Order';
import AdminAPI from '../../network/AdminAPI';
import OrderHistoryModal from '../modals/OrderHistoryModal';

const ITEMS_PER_PAGE = 25;

interface OrderHistoryState {
  showLoading: boolean;
  selectedOrder: Order;
  resultQueryOrders;
  tableData: {}[];
  filter?: {
    ReqNum;
    FacilityID;
    ProductID;
  };
  BeginDate: string;
  EndDate: string;
  direction?: TableOrder;
  page_options: ReactSelect[];
  selected_page?: { label; value };
  orders: { label; value }[];
  products;
  facilities;
  services;
}

export default class OrderHistory extends React.Component<any, OrderHistoryState> {
  constructor(props) {
    super(props);

    this.state = {
      showLoading: false,
      selectedOrder: {} as Order,
      tableData: [] as any,
      resultQueryOrders: [] as any,
      filter: {
        ReqNum: null,
        FacilityID: null,
        ProductID: null,
      },
      BeginDate: null,
      EndDate: null,
      direction: 'asc',
      page_options: [{ label: '1', value: '1' }],
      selected_page: { label: '1', value: 1 },
      orders: [],
      products: [],
      facilities: [],
      services: [],
    };
  }

  componentDidMount() {
    document.title = 'Order History Page';
    this.setState({ showLoading: true }, async () => {
      const orders = await ShopAPI.getOrders();
      const products = await ShopAPI.getProducts();
      const facilities = await AdminAPI.getFacilitiesForSubmissionForm();
      

      this.setState({
        //@ts-ignore
        orders: orders,
        products: products,
        facilities: facilities.authorizedFacilities,
        showLoading: false,
      });
    });
    this.queryOrdersData(1);
  }

  queryOrdersData(page: number) {
    let filter = JSON.parse(JSON.stringify(this.state.filter));
    if ((!this.state.BeginDate && this.state.EndDate) || (this.state.BeginDate && !this.state.EndDate)) {
      return sweetalert.fire({ title: '', text: 'Must select both Begin Date and End Date', icon: 'error' });
    }
    if (this.state.BeginDate && this.state.EndDate && this.state.BeginDate > this.state.EndDate) {
      return sweetalert.fire({ title: '', text: 'Begin Date must be before End Date', icon: 'error' });
    }
    if (this.state.BeginDate && this.state.EndDate) {
      filter.BeginDate = this.state.BeginDate;
      filter.EndDate = this.state.EndDate;
    }

    this.setState({ showLoading: true }, async () => {
      let response = await ShopAPI.filterOrders({ filter: filter });

      if (response.data.length < 1) {
        this.setState({ showLoading: false, tableData: [], resultQueryOrders: null });
        return sweetalert.fire({ title: '', text: 'No Orders returned', icon: 'info' });
      }
      if (!response.success) {
        return sweetalert.fire({
          title: '',
          text: 'Unable to filter Orders data at this time',
          icon: 'error',
        });
      }

      this.setState({
        tableData: slicePages(response.data, page, ITEMS_PER_PAGE),
        resultQueryOrders: response.data,
        page_options: getPageOptions(getNumPages(response.data, ITEMS_PER_PAGE)),
        showLoading: false,
      });
    });
  }

  handleExportToCSV() {
    this.setState({ showLoading: true }, async () => {
      await NetworkUtil.downloadCSV('/api/admin/shop/orders/csv', 'Order History Data.xlsx', {
        filter: this.state.filter,
      });
      this.setState({ showLoading: false });
    });
  }

  changePage(page: number) {
    let allorders = this.state.resultQueryOrders;
    let returnData = slicePages(allorders, page, ITEMS_PER_PAGE);
    this.setState({ tableData: returnData });
  }

  renderResultsFilterFields() {
    return (
      <FilterCard
        fields={[
          {
            label: 'Order Number',
            key: 'ReqNum',
            type: FIELD_TYPE.TEXT,
          },
          {
            label: 'Facility',
            key: 'FacilityID',
            type: FIELD_TYPE.SELECT,
            options: getLabels(this.state.facilities, 'facility'),
            isMapped: true,
            isMulti: true,
            textType: 'text',
            isFilter: true,
          },
          {
            label: 'Product',
            key: 'ProductID',
            type: FIELD_TYPE.SELECT,
            options: getLabels(this.state.products, 'products'),
            isMapped: true,
            isMulti: true,
            textType: 'text',
            isFilter: true,
          },
        ]}
        filterChanged={(e) => this.setState({ filter: e })}
      />
    );
  }

  useSorter(col: Column) {
    let sorter = new Sorter<any>();

    this.setState({
      tableData: sorter.sortByKey(this.state.tableData, col.key as keyof any, this.state.direction),
      direction: this.state.direction === 'asc' ? 'desc' : 'asc',
    });
  }

  getDateRange(beginStateToSet, beginState, endStateToSet, endState, label, tooltip) {
    if ((window.innerWidth > 1000 && window.innerWidth <= 1200) || window.innerWidth >= 1400) {
      return (
        <div className="form-group row">
          <div className={'col-sm-4'}>
            <label htmlFor={'BeginDate'} className={'pt-1 col-form-label'}>
              {' '}
              {'Begin Date'}{' '}
            </label>
          </div>

          <div className={'col-sm-1 p-0'}>
            <label id={`BeginDate`} aria-label="" htmlFor="beginDate">
              {'Begin'}:{' '}
            </label>
          </div>
          <div className={'col-sm-2 p-0'} id={'BeginDate'}>
            <input
              aria-labelledby={`BeginDate`}
              className={'form-control'}
              autoComplete={'off'}
              type={'date'}
              name={'beginDate'}
              onChange={(e) => {
                this.setState({ BeginDate: e.target.value });
              }}
              value={this.state.BeginDate}
            />
          </div>
          <div className="col-sm-1"></div>
          <div className={'col-sm-1 p-0'}>
            <label id={`EndDate`} htmlFor="endDate">
              {'End'}:{' '}
            </label>
          </div>
          <div className={'col-sm-2 p-0'} id={'EndDate'}>
            <input
              aria-labelledby={`EndDate`}
              className={'form-control'}
              autoComplete={'off'}
              type={'date'}
              name={'endDate'}
              onChange={(e) => {
                this.setState({ EndDate: e.target.value });
              }}
              value={this.state.EndDate}
            />
          </div>
        </div>
      );
    } else {
      return (
        <div className="form-group row mb-0 pl-3">
          <div className={'col-10 col-md-8 pl-0'}>
            <label htmlFor={'BeginDate'} className={'py-2 col-form-label'}>
              {' '}
              {'Begin Date'}{' '}
            </label>
          </div>

          <div className={'col-12 col-md-10 pl-0 pr-1'}>
            <div className="row">
              <div className={'col-4'}>
                <label id={`BeginDate`} aria-label="" htmlFor="beginDate">
                  {'Begin'}:{' '}
                </label>
              </div>
              <div className={'col-7 ml-4'} id={'BeginDate'}>
                <input
                  aria-labelledby={`BeginDate`}
                  className={'form-control'}
                  autoComplete={'off'}
                  type={'date'}
                  name={'beginDate'}
                  onChange={(e) => {
                    this.setState({ BeginDate: e.target.value });
                  }}
                  value={this.state.BeginDate}
                />
              </div>
            </div>
            <div className={'row'}>
              <div className={'col-4'}>
                <label id={`EndDate`} htmlFor="endDate">
                  {'End'}:{' '}
                </label>
              </div>
              <div className={'col-7 ml-4'} id={'EndDate'}>
                <input
                  aria-labelledby={`EndDate`}
                  className={'form-control'}
                  autoComplete={'off'}
                  type={'date'}
                  name={'endDate'}
                  onChange={(e) => {
                    this.setState({ EndDate: e.target.value });
                  }}
                  value={this.state.EndDate}
                />
              </div>
            </div>
          </div>
        </div>
      );
    }
  }

  downloadReceipt(transactionID, productMap) {
    if (!transactionID || transactionID.length < 1) {
      return sweetalert.fire({ title: '', text: 'Error downloading receipt. Please try again.', icon: 'error' });
    }

    this.setState({ showLoading: true }, async () => {
      try {
        const fileURL = await ShopAPI.getReciptInOrderHistory(transactionID,productMap);
        if (!fileURL || (fileURL as any).success === false) {
          return sweetalert.fire({
            title: '',
            text: 'Error downloading receipt. Please try again.',
            icon: 'error',
          });
        }

        const link = document.createElement('a');
        link.href = fileURL as string;
        link.setAttribute('rel', 'noopener noreferrer');
        link.download = `${transactionID}_Receipt.pdf`;
        document.body.appendChild(link);
        link.click();
        link.remove();

        this.setState({ showLoading: false });
      } catch (e) {
        sweetalert.fire({
          icon: 'error',
          title: '',
          text: 'Error downloading receipt. Please try again.',
        });
        this.setState({ showLoading: false });
      }
    });
  }

  render() {
    // console.log('OrderHistory STATE', this.state)
    return (
      <React.Fragment>
        <PaginationTool />
        <Overlay show_loading={this.state.showLoading} />
        <OrderHistoryModal
          selectedOrder={this.state.selectedOrder}
          facilities={this.state.facilities}
          products={this.state.products}
        />

        <div className="container-fluid ">
          <div className={'row'}>
            <div className="col-12 col-md-12 col-lg-8 pt-2">
              <main id="main-content" tabIndex={-1} aria-label="Order History">
                <div className="card mb-2">
                  <div className="card-header verlag-bold">
                    <h3>Order History</h3>
                  </div>
                  <div className="card-body">
                    {this.renderResultsFilterFields()}
                    {this.getDateRange('BeginDate', this.state.BeginDate, 'EndDate', this.state.EndDate, '', '')}
                  </div>
                  <div className="card-footer">
                    <button
                      className={'btn immySubmitButtonOutline'}
                      onClick={() => {
                        this.setState(
                          {
                            selected_page: { label: 1, value: 1 },
                          },
                          () => {
                            this.queryOrdersData(this.state.selected_page.value);
                          }
                        );
                      }}
                    >
                      Search
                    </button>
                  </div>
                </div>
              </main>
            </div>
            {this.state.tableData && this.state.tableData.length > 0 && (
              <div className="col-12 col-md-12 col-lg-12 pt-2">
                <div className="card mt-2" style={{ marginBottom: '4rem' }}>
                  <div className="card-header verlag-bold stickToTop">
                    <h4 className="text-center text-md-left">
                      Orders
                      <section className="tableHeaderSection float-md-right d-flex justify-content-around">
                        <h4 className={'float-md-right'} aria-label="Total Records" role="alert">
                          Total: {this.state.resultQueryOrders.length}
                        </h4>
                        <h4 className="d-inline-block float-right align-middle pr-2 ml-5">Page </h4>
                        <div className=" align-middle float-right pages ">
                          <Select
                            isSearchable={true}
                            placeholder={'1'}
                            noOptionsMessage={() => 'No option'}
                            value={this.state.selected_page}
                            aria-label="Table Page Number"
                            onChange={(e: ReactSelect) =>
                              this.setState({ selected_page: e }, () => this.changePage(e.value))
                            }
                            className={'state_select'}
                            options={this.state.page_options}
                          />
                        </div>
                      </section>
                      <button
                        className={'d-none d-md-inline btn btn-outline-primary ml-3'}
                        onClick={() => this.handleExportToCSV()}
                      >
                        Export to CSV
                      </button>
                    </h4>
                  </div>
                  <div className="card-body p-0 m-0 table-responsive">
                    <SimpleTable
                      columns={[
                        {
                          label: 'Order #',
                          key: 'ReqNum',
                          rawFormat: (val) => {
                            return (
                              <a
                                href={'#'}
                                className={'tableNameLinkColor'}
                                onClick={() => {
                                  this.setState({ selectedOrder: val }, () =>
                                    showModalNoOutsideClick(OrderHistoryModal.ID)
                                  );
                                }}
                              >
                                {val.ReqNum}
                              </a>
                            );
                          },
                        },
                        {
                          label: 'Order Date',
                          key: 'CreatedDate',
                          formatFunc: parseDate,
                        },
                        {
                          label: 'Facility',
                          key: 'FacilityID',
                          rawFormat: (v) => {
                            let facilityName =
                              v.FacilityID && this.state.facilities && this.state.facilities.length > 0
                                ? this.state.facilities.find((f) => f.ID === v.FacilityID).FacilityName
                                : 'N/A';
                            return <div>{facilityName}</div>;
                          },
                        },
                        {
                          label: 'Product',
                          key: 'ProductID',
                          rawFormat: (v) => {
                            let htmlString = getDataForTableFromJSON(v.ProductMap, this.state.products, 'product');
                            return <div>{htmlString}</div>;
                          },
                        },
                        {
                          label: 'Tracking #',
                          key: 'TrackingNumber',
                          rawFormat: (v) => {
                            return <div>{v.TrackingNumber}</div>;
                          },
                        },
                        {
                          label: 'Status',
                          key: 'Status',
                          rawFormat: (v) => {
                            return <div>{v.TrackingStatus}</div>;
                          },
                        },
                        
                        {
                          label: '',
                          key: '',
                          rawFormat: (v) => (
                            <button
                              type={'button'}
                              className={'btn btn-outline-success'}
                              onClick={() => this.downloadReceipt(v.TransactionID, v.ProductMap)}
                            >
                              {'Download Receipt'}
                            </button>
                          ),
                        },
                      ]}
                      table_data={this.state.tableData}
                      columnClickedCallback={(col) => {
                        this.useSorter(col);
                      }}
                    />
                  </div>
                </div>
              </div>
            )}
          </div>
        </div>
      </React.Fragment>
    );
  }
}
